import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { ThemeProvider } from '@ui/providers/theme-provider';
import { startWebDiagnostics } from '@closet-theory/web-diagnostics';
import { startStylistAnalytics } from './analytics';
import { App } from './App';
import './styles.css';

// Neither console reported an error anywhere until this was wired: of the
// three apps the telemetry endpoint accepts, production had seen no admin
// events at all and a single stylist one.
// Vite types these as `any`; read them through one narrowed view instead of
// three unchecked reads.
const buildEnv = import.meta.env as Record<string, string | undefined>;

startWebDiagnostics({
  app: 'stylist',
  apiBaseUrl: buildEnv.VITE_API_BASE_URL ?? window.location.origin,
  release: buildEnv.VITE_RELEASE ?? 'development',
  appVersion: buildEnv.VITE_APP_VERSION ?? '0.0.0',
});

// Product analytics, separate from the diagnostics above on purpose: errors
// go to our own telemetry endpoint and must not depend on a vendor being
// reachable. Inert unless both VITE_POSTHOG_PROJECT_TOKEN and VITE_POSTHOG_HOST are
// set. See ./analytics.ts for why replay and autocapture are off.
startStylistAnalytics(buildEnv);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider defaultTheme="system">
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);
